import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"

export default function DialogStatus(props) {
    
    return (
        <Dialog
            open={props.open}
            keepMounted
            onClose={() => props.setOpen(false)}
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle>{"Toda a agenda do participante será cancelada"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    {`Ao alterar o Status para ${props.statusLabel} toda a agenda dessa inscrição será liberada`}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={async () => {
                        await props.statusCb()
                        props.setOpen(false)
                    }}
                >
                    Confirmar
                </Button>
                <Button onClick={async () => props.setOpen(false)}>
                    Cancelar
                </Button>
            </DialogActions>
        </Dialog>
    )
}